<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-col gap-(--space-6)">
    <div class="flex flex-col gap-(--space-2)">
      <label for="name" class="font-medium">{{ 'common.labels.name' | transloco }}<sup>*</sup></label>
      <input
        id="name"
        type="text"
        pInputText
        formControlName="name"
        class="w-full"
        [class.p-invalid]="nameInvalid()"
        [attr.aria-invalid]="nameInvalid() || null"
        [attr.aria-describedby]="nameNotUnique() ? 'table-name-error' : null"
        [maxlength]="30" />
      @if (nameNotUnique()) {
        <small id="table-name-error" role="alert" class="text-(color:--p-red-500)">{{ 'validation.duplicateName' | transloco }}</small>
      }
    </div>

    <div class="flex flex-col gap-(--space-2)">
      <label for="description" class="font-medium">{{ 'common.labels.description' | transloco }}</label>
      <textarea id="description" pTextarea formControlName="description" rows="3" class="w-full resize-none"></textarea>
    </div>

    <div class="grid grid-cols-2 gap-(--space-4)">
      <div class="flex flex-col gap-(--space-2)">
        <label for="periodicity" class="font-medium">{{ 'tables.periodicity.label' | transloco }}<sup>*</sup></label>
        <p-select
          id="periodicity"
          formControlName="periodicity"
          [options]="periodicityOptions()"
          optionLabel="translatedLabel"
          optionValue="value"
          [placeholder]="'common.placeholders.selectOption' | transloco"
          [class.p-invalid]="periodicityInvalid()"
          [attr.aria-invalid]="periodicityInvalid() || null"
          styleClass="w-full"
          appendTo="body" />
      </div>

      <div class="flex flex-col gap-(--space-2)">
        <label for="startTime" class="font-medium">{{ 'tables.startTime.label' | transloco }}</label>
        <ces-hourpicker id="startTime" formControlName="startTimePeriod" [showSeconds]="false" />
        @if (!startTimeEnabled()) {
          <small class="text-(color:--text-secondary)">{{ 'tables.startTime.disabledHint' | transloco }}</small>
        }
      </div>
    </div>

    @if (showDayOfWeek() || showDayOfMonth() || showMonth()) {
      <div class="grid grid-cols-2 gap-(--space-4)">
        @if (showMonth()) {
          <div class="flex flex-col gap-(--space-2)">
            <label for="month" class="font-medium">{{ 'entities.automaticMeasure.fields.month' | transloco }}</label>
            <p-select
              id="month"
              formControlName="month"
              [options]="monthOptions"
              optionLabel="label"
              optionValue="value"
              styleClass="w-full"
              appendTo="body" />
          </div>
        }

        @if (showDayOfWeek()) {
          <div class="flex flex-col gap-(--space-2)">
            <label for="dayOfWeek" class="font-medium">{{ 'entities.automaticMeasure.fields.dayOfWeek' | transloco }}</label>
            <p-select
              id="dayOfWeek"
              formControlName="dayOfWeek"
              [options]="dayOfWeekOptions"
              optionLabel="label"
              optionValue="value"
              styleClass="w-full"
              appendTo="body" />
          </div>
        }

        @if (showDayOfMonth()) {
          <div class="flex flex-col gap-(--space-2)">
            <label for="dayOfMonth" class="font-medium">{{ 'entities.automaticMeasure.fields.dayOfMonth' | transloco }}</label>
            <p-select
              id="dayOfMonth"
              formControlName="dayOfMonth"
              [options]="dayOfMonthOptions"
              optionLabel="label"
              optionValue="value"
              styleClass="w-full"
              appendTo="body" />
          </div>
        }
      </div>
    }

    <div class="flex flex-col gap-(--space-2)">
      <label class="font-medium">{{ 'tables.displayOrder.label' | transloco }}</label>
      <div class="flex gap-(--space-4)">
        <div class="flex items-center gap-(--space-2)">
          <p-radioButton inputId="orderNewest" formControlName="chronologicalOrder" [value]="false" />
          <label for="orderNewest" class="cursor-pointer">{{ 'tables.displayOrder.newestFirst' | transloco }}</label>
        </div>
        <div class="flex items-center gap-(--space-2)">
          <p-radioButton inputId="orderOldest" formControlName="chronologicalOrder" [value]="true" />
          <label for="orderOldest" class="cursor-pointer">{{ 'tables.displayOrder.oldestFirst' | transloco }}</label>
        </div>
      </div>
    </div>

    <ces-dialog-footer
      [submitDisabled]="form.invalid"
      [submitTooltip]="form.invalid ? ('common.tooltips.formIncomplete' | transloco) : ''"
      (onCancel)="onCancel()"
      (onSubmit)="onSubmit()" />
  </div>
</form>
